import { createAsyncThunk } from "@reduxjs/toolkit"
import { post, get } from "helpers/api_helper"
import { API_LOGS, API_LOG_DETAILS } from "helpers/url_helper"

export const getApiLogs = createAsyncThunk(API_LOGS, async payload => {
  const response = await post(API_LOGS, payload)
  return response
})

export const getApiLogDetails = createAsyncThunk(API_LOG_DETAILS, async id => {
  const response = await get(`${API_LOG_DETAILS}/${id}`)
  return response
})
